export default "__VITE_ASSET__C9ZcKdCm__$_?string__"